<template>
  <PasswordConfigurationMulti
    v-model="item"
    :icon="$options.config.icon"
    :optionsAccountLockout="$options.config.optionsAccountLockout"
    :optionsPasswordExpiration="$options.config.optionsPasswordExpiration"
    :title="$options.config.title"
  />
</template>

<script>
import {
  ItemTypeConsts,
  ItemTypeDisplayNames,
} from 'client/util/Constants';
import PasswordConfigurationMulti from 'client/settings/Security/PasswordConfigurationMulti.vue';

const config = {
  icon: 'radius',
  key: 'radiusServers',
  optionsAccountLockout: [
    { label: 'Maintain users', value: 'MAINTAIN' },
    { label: 'Remove users', value: 'REMOVE' },
  ],
  optionsPasswordExpiration: [
    { label: 'Maintain users', value: 'MAINTAIN' },
    { label: 'Remove users', value: 'REMOVE' },
  ],
  title: ItemTypeDisplayNames[ItemTypeConsts.radiusServer],
};

export default {
  name: 'PasswordConfigurationRadius',

  components: {
    PasswordConfigurationMulti,
  },

  props: {
    value: {
      type: Array,
      default: () => ([]),
    },
  },

  computed: {
    item: {
      get() {
        return this.value;
      },
      set(newValue) {
        this.$emit('input', newValue);
      },
    },
  },

  config,
};
</script>
